import React from "react"
import { Box, Text, Flex, Heading } from "@chakra-ui/react"
import ResolvedImage from "@app/components/ResolvedImage"

type Props = {
  productInfo: string
  productFragrences: GatsbyTypes.SanityProduct["fragrences"]
}

const ProductTabDescription: React.FC<Props> = ({ productInfo, productFragrences }) => {
  return (
    <Flex gap={{ base: "16px", lg: "40px" }} flexDir={{ base: "column", lg: "row" }}>
      <Box p={{ base: "16px", lg: "32px" }} w={{ base: "100%", lg: "50%" }}>
        <Heading fontSize={{ base: 24, lg: 32 }} fontWeight={700}>
          {productFragrences?.excerpt ? productFragrences.excerpt : "Description"}
        </Heading>
        <Box
          dangerouslySetInnerHTML={{ __html: productInfo }}
          sx={{ a: { textDecoration: "none" }, ul: { mt: "16px", ml: "4" }, li: { pl: "0px", listStyleType: "disc" } }}
        />
        {productFragrences?.smells && productFragrences?.smells.length > 0 && productFragrences.title && (
          <Flex flexDir="column" gap="4px" mt="8px">
            <Heading variant="heading16" fontWeight="bold">
              {productFragrences.title}
            </Heading>
            <Text>
              {productFragrences.smells?.map((smell, index) => {
                if (index === productFragrences.smells.length - 1) {
                  return <span key={smell}>{`${smell}`}</span>
                }
                return <span key={smell}>{`${smell}, `}</span>
              })}
            </Text>
          </Flex>
        )}
      </Box>
      <ResolvedImage image={productFragrences?.image} w={{ base: "100%", lg: "50%" }} h="100%" objectFit="cover" loading="lazy" />
    </Flex>
  )
}

export default React.memo(ProductTabDescription)
